<template>
    <v-container>
        <v-row dense>
            <v-col cols=3>
                <v-card class="py-3 px-5">
                    <v-card-text>
                        <v-row align="center">
                            <v-btn icon class="DC-AC-icon">
                                <span class="mdi mdi-contrast"></span>
                            </v-btn>
                            <div class="ms-4" style="color:#000;">
                                DC<br><b>{{ numberWithCommas(total_DC) }} MWp</b>
                            </div>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols=3>
                <v-card class="py-3 px-5">
                    <v-card-text>
                        <v-row align="center">
                            <v-btn icon class="DC-AC-icon">
                                <span class="mdi mdi-pulse"></span>
                            </v-btn>
                            <div class="ms-4" style="color:#000;">
                                AC<br><b>{{ numberWithCommas(total_AC) }} MW</b>
                            </div>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols=3>
            <v-card class="py-3 px-4" style="height: 68px;">
                <div id="graph">
                    <v-select
                        hide-details
                        attach="#graph"
                        v-model="group"
                        :items="list_groups"
                        v-on:change="getDataByGroup"
                        outlined
                        dense
                        label="グループ"
                        no-data-text="該当データがありません"
                    >
                    </v-select>
                </div>
            </v-card>
           </v-col> 
        </v-row>
        <v-data-table
        dense
        class="mt-3 elevation-1"
        fixed-header
        :headers="headers"
        :items="annotations"
        :search="search"
        :loading="loading"
        loading-text="ローディング..."
        no-data-text="該当データがありません。"
        no-results-text="検索の結果が見つかりません。"
        disable-pagination
        hide-default-footer
        @click:row="(annotation) => {
            viewSite(annotation)
        }" 
        @current-items="currentItems"
        :sort-by="['shootingDate']"
        :sort-desc="[true]"
        >
        <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>
                    <b>発電所一覧</b>
                    <span>（{{ total }} 件）</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="checkRole() && group == 0" height="40px" class="mr-4" color="primary" @click="download()"><v-icon>mdi-download</v-icon>ダウンロード</v-btn>
                <v-text-field
                    style="width:256px;"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="検索"
                    single-line
                    outlined
                    dense
                    hide-details
                    class="shrink"
                ></v-text-field>
            </v-toolbar>
        </template>
        <template v-slot:item.plantDC="{ item }">
            {{ numberWithCommas(round_up_DC(item.plantDC)) }}
        </template>
        </v-data-table>
        <v-card class="mt-4 donut">
            <v-toolbar flat>
                <v-toolbar-title>
                    <b>全発電所の異常合計</b>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <apexchart
            v-if="check"
            type="donut"
            height="400"
            :options="options"
            :series="series"
            ></apexchart>
        </v-card>
        <v-card v-if="openGraphPlant" class="mt-4">
            <v-toolbar flat>
                <v-toolbar-title>
                    <b>発電所毎の異常</b>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <apexchart
            class="pl-100"
            height="400"
            :options="chartBar.options"
            :series="chartBar.series"
            ></apexchart>
        </v-card>
    </v-container>
</template>

<script>
import {store} from '../store';
import VueApexCharts from 'vue-apexcharts'
import download from "downloadjs";
export default {
    name: "Dashboard",
    components: {
        apexchart: VueApexCharts,
    },

    data() {
        return {
            // アノテーション種類定義
            types: [
                { text: "ホットスポット", value: "cell" },
                { text: "マルチホットスポット", value: "multicell" },
                { text: "クラスタバイパス", value: "cluster" },
                { text: "モジュール異常", value: "module" },
                { text: "ストリング異常", value: "string" },
                { text: "ジャンクションボックス過熱", value: "junction" },
                { text: "ＰＩＤ現象の疑い", value: "pid" },
                { text: "影", value: "shadow" },
            ],
            // 合計異常グラフの apextcharts js
            
            options: {
                chart: {
                    type: 'donut',
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom',
                        }
                    }
                }],
                plotOptions: {
                    pie: {
                        donut: {
                        labels: {
                            show: true,
                            total: {
                                show: true,
                                showAlways: true,
                                label: '合計',
                                fontSize: '22px',
                                fontFamily: 'Helvetica, Arial, sans-serif',
                                fontWeight: 600,
                                color: '#373d3f',
                                formatter: function (w) {
                                    return w.globals.seriesTotals.reduce((a, b) => {
                                    return a + b
                                    }, 0)

                                }
                            }
                        }
                        }
                    }
                },
                labels: ["ホットスポット", "マルチホットスポット", "クラスタバイパス", "モジュール異常", "ストリング異常", "ジャンクションボックス過熱", "ＰＩＤ現象の疑い", "影" ],
                noData: {
                    text: '該当なし',
                    align: 'center',
                    verticalAlign: 'top',
                    offsetY: 10,
                    style: {
                        fontSize: '20px',
                    }
                },
                legend: {
                    width: 450,
                    show: true,
                    formatter: function (val, opts) {
                        if (opts.w.globals.seriesPercent[opts.seriesIndex]){
                            if (opts.w.globals.seriesPercent[opts.seriesIndex][0]){
                                if (opts.w.globals.seriesPercent[opts.seriesIndex][0] < 0.01 && opts.w.globals.seriesPercent[opts.seriesIndex][0] > 0){
                                    return "<v-card class='labels'><v-card-title style='width:230px; display: inline-flex;'>"+ val +"</v-card-title>"+
                                    "<v-card-title style='display: inline-flex;'> <div class='text-right' style='font-weight: bold; width:90px;'>"+ opts.w.globals.series[opts.seriesIndex] +"</div></v-card-title>"+
                                    "<v-card-title style='display: inline-flex;'><div class='text-right' style='width:80px;'>"+ opts.w.globals.seriesPercent[opts.seriesIndex][0].toFixed(1-Math.floor(Math.log(opts.w.globals.seriesPercent[opts.seriesIndex][0])/Math.log(10))) +"</div>%</v-card-title></v-card>"
                                }
                                return "<v-card class='labels'><v-card-title style='width:230px; display: inline-flex;'>"+ val +"</v-card-title>"+
                                "<v-card-title style='display: inline-flex;'><div class='text-right' style='font-weight: bold; width:90px;'>"+ opts.w.globals.series[opts.seriesIndex] +"</div></v-card-title>"+
                                "<v-card-title style='display: inline-flex;'><div class='text-right' style='width:80px;'>"+ (Math.round(opts.w.globals.seriesPercent[opts.seriesIndex][0] * 10) / 10).toFixed(1) +"%</div></v-card-title></v-card>"
                            }
                        }
                        return "<v-card class='labels'><v-card-title style='width:230px; display: inline-flex;'>"+ val +"</v-card-title>"+
                        "<v-card-title style='display: inline-flex;'><div class='text-right' style='font-weight: bold; width:90px;'>"+ opts.w.globals.series[opts.seriesIndex] +"</div></v-card-title>"+
                        "<v-card-title style='display: inline-flex;'><div class='text-right' style='width:80px;'>"+ 0 +"%<div></v-card-title></v-card>"
                    },
                    onItemClick: {
                        toggleDataSeries: false
                    },
                    onItemHover: {
                        highlightDataSeries: false
                    },
                },
                colors: ['rgba(255, 109, 0, 0.7)', 'rgba(244, 221, 26, 1)', 'rgba(213, 0, 0, 0.7)', 'rgba(150, 0, 61, 0.7)', 'rgba(64, 0, 124, 0.7)', 'rgba(76, 175, 80, 0.7)', 'rgba(27, 94, 32, 0.7)', 'rgba(45, 121, 179, 0.7)' ],
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return(Math.round(val * 10) / 10).toFixed(1) + "%";
                    },
                },
            },

            // 異常一覧のjs
            loading: false,
            search: '',
            headers: [
                { text: '発電所名', value: 'plantName', align: 'left',},
                { text: 'DC', value: 'plantDC', align: 'right',},
                { text: '異常の数', value: 'num_errors', align: 'right', },
                { text: '点検日', value: 'shootingDate', align: 'center', },
            ],
            annotations: [],
            total_DC: 0,
            total_AC:0,
            group: null,
            list_groups: [],
            role: localStorage.getItem('drs_role'),
            user: localStorage.getItem('drs_user'),
            total: 0,
            series:[],
            check: false,

            openGraphPlant: false,
            chartBar: {
                series: [],
                options: {
                    chart: {
                        type: 'bar',
                        stacked: true,
                        toolbar: {
                            show: false,
                        },
                        zoom: {
                            enabled: false,
                        }
                    },
                    responsive: [{
                        breakpoint: 100,
                        options: {
                            legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                            }
                        }
                    }],
                    plotOptions: {
                        bar: {
                            size: '65%',
                            horizontal: false,
                            borderRadius: 0,
                            columnWidth: '10px',
                        },
                    },
                    noData: {
                        text: '該当なし',
                        align: 'center',
                        verticalAlign: 'top',
                        offsetY: 0,
                        offsetX: 0,
                        style: {
                            fontSize: '20px',
                        }
                    },
                    xaxis: {
                        type: 'category',
                        categories: [],
                        labels: {
                            trim: true,
                            maxHeight: 300,
                        }
                    },
                    yaxis: {
                        show: true,
                    },
                    legend: {
                        show: true,
                        position: 'bottom',
                        offsetX: 0,
                        offsetY: 0, 
                        markers: {
                            width: 12,
                            height: 12,
                            strokeWidth: 0,
                            strokeColor: '#fff',
                            fillColors: ['rgba(255, 109, 0, 0.7)', 'rgba(244, 221, 26, 1)', 'rgba(213, 0, 0, 0.7)', 'rgba(150, 0, 61, 0.7)', 'rgba(64, 0, 124, 0.7)', 'rgba(76, 175, 80, 0.7)', 'rgba(27, 94, 32, 0.7)', 'rgba(45, 121, 179, 0.7)' ],
                            radius: 12,
                            offsetX: 0,
                            offsetY: 0
                        },                      
                    },
                    fill: {
                        colors: ['rgba(255, 109, 0, 0.7)', 'rgba(244, 221, 26, 1)', 'rgba(213, 0, 0, 0.7)', 'rgba(150, 0, 61, 0.7)', 'rgba(64, 0, 124, 0.7)', 'rgba(76, 175, 80, 0.7)', 'rgba(27, 94, 32, 0.7)', 'rgba(45, 121, 179, 0.7)' ],
                        opacity: 1
                    },
                },
            },

        }
    },
    methods: {
        resetData() {
            this.loading = true;
            // this.list_groups = [];
            this.group = 0;
            this.series = [];
            this.total = 0;
        },
        getData() {
            this.resetData();
            this.axios.get("/api/dashboard/")
            .then((response) => {
                this.annotations = response.data.annotations;
                this.total = response.data.annotations.length;
                this.total_DC = response.data.total_DC;
                this.total_AC = response.data.total_AC;

                for (var i in response.data.list_errors) {
                    this.series.push(response.data.list_errors[i]);
                }
                if (this.series.every(item => item === 0)){
                    this.series = [];
                    this.options.legend["showForNullSeries"] = false;
                }
                else {
                    this.options.legend["showForNullSeries"] = true;
                }
                
                this.check = true;
                if (response.data.groups && this.list_groups.length == 0) {
                    this.list_groups = [];
                    if (response.data.groups.length == 1) {
                        this.list_groups.push({
                            value: response.data.groups[0].id,
                            text: response.data.groups[0].name,
                        });
                        this.group = response.data.groups[0].id;
                        // update lai graph plant
                        this.getDataByGroup();
                    }
                    if (response.data.groups.length > 1) {
                        this.list_groups.push(
                            {
                                value: 0,
                                text: "全て",
                            }
                        );
                        response.data.groups.sort(function(a, b){
                            if(a.name < b.name) { return -1; }
                            if(a.name > b.name) { return 1; }
                            return 0;
                        });
                        response.data.groups.forEach(element => {
                            this.list_groups.push({
                                value: element.id,
                                text: element.name,
                            })
                        });
                    }
                }
            })
            .catch(() => {
                store.showErrorDialog("エラーが発生しました。再度試してください。");
            })
            .then(()=>{
                this.loading = false;
            })
        },
        getTextAnnotation(type) {
            if(type == null) {
                return "";
            } else {
                const annotationTypes = this.types;
                return annotationTypes.find(x =>x.value == type).text;
            }
        },

        viewSite(annotation) {
            this.$router.push('/site/' + annotation.uuid);
        },
        getDataByGroup() {
            this.series = [];
            this.check = false;
            this.openGraphPlant = false;
            this.chartBar.series = [];
            this.chartBar.options.xaxis.categories = [];
            if (this.group == 0) {
                this.getData();
            } else {
                this.axios.post('/api/dashboard/'+ this.group)
                .then((response)=>{
                    this.annotations = response.data.annotations;
                    this.total = response.data.annotations.length;
                    this.total_DC = response.data.total_DC;
                    this.total_AC = response.data.total_AC;

                    for (var i in response.data.list_errors) {
                        this.series.push(response.data.list_errors[i]);
                    }
                    if (this.series.every(item => item === 0)){
                        this.series = [];
                        this.options.legend["showForNullSeries"] = false;
                    } else {
                        this.options.legend["showForNullSeries"] = true;
                    }
                    this.check = true;

                    // show graph plant
                    // if (this.checkRole()) {
                        this.openGraphPlant = true;
                        for (var category in response.data.categories) {
                            this.chartBar.options.xaxis.categories.push(response.data.categories[category]['plantName']);
                        }
                        for (var idx in response.data.series) {
                            this.chartBar.series.push(
                                {
                                    name: this.getTextAnnotation(response.data.series[idx]['name']),
                                    data: response.data.series[idx]['data']
                                }
                            );
                        }
                        if (response.data.categories.length == 0 ) {
                            this.chartBar.series = [];
                            this.chartBar.options.xaxis.categories = [];
                            this.chartBar.options.yaxis["showForNullSeries"] = false;
                            this.chartBar.options.legend["showForNullSeries"] = false;
                        }
                        if (response.data.categories.length == 1 ) {
                            if (this.chartBar.series.every(item => item['data'][0] === 0)){
                                this.chartBar.series = [];
                                this.chartBar.options.xaxis.categories = [];
                                this.chartBar.options.yaxis["showForNullSeries"] = false;
                                this.chartBar.options.legend["showForNullSeries"] = false;
                            }
                            else {
                                this.chartBar.options.legend["showForNullSeries"] = true;
                            }

                        }
                        
                    // }
                })
            }
        },
        round_up_DC(val) {
            const data = (Math.round(val * 10) /  10).toFixed(1);
            if (data == 0) {
                return 0;
            } else {
                return data;
            }
        },
        checkRole () {
            return this.user.includes('@east-e.co.jp');
        },
        currentItems: function(value){
            this.total = value.length;
        },
        numberWithCommas(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        download() {
            store.showLoadingOverlay(true);
            let fileName = '集計.xlsx'
            const x=new XMLHttpRequest();
            x.open( "GET", '/api/dashboard/download/', true);
            x.responseType="blob";
            x.onload= function(e){
                if (x.status === 200){
                download(e.target.response, fileName);
                }
                else {
                store.showErrorDialog('エラーが発生しました。再度試してください。');
                }
                store.showLoadingOverlay(false);
            };
            x.send();
        }

    },
    created() {
        this.getData();
    },
}
</script>

<style scoped>
.DC-AC-icon {
    background-color: lightblue !important;
    float: left;
    color: blue !important;
    font-size: x-large;
    border-radius: 50%;
}
>>>.v-menu__content {
    top: initial !important;
    left: initial !important;
}
>>>.v-data-table__wrapper {
    max-height: 352px;
}
>>>.v-data-table header {
    border-radius: 4px;
}
>>>.donut .apexcharts-legend-series {
    position: relative;
}
>>>.donut .apexcharts-legend-text {
    position: absolute;
    width: calc(100% - 12px);
}
>>>.labels {
    position: absolute;
    width: 100% !important;
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
}
>>> tbody tr :hover {
  cursor: pointer;
}
</style>
